import { c as _c } from "react/compiler-runtime";
import { Card, InlineAlert, LinkButton } from '@onefootprint/ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
type ContentCardProps = {
  headerTitle: string;
  children: ReactNode;
  onSelectAll?: () => void;
  selectAllLabel?: string;
  isFirmEmployeeOnly?: boolean;
};
const ContentCard = t0 => {
  const $ = _c(15);
  const {
    headerTitle,
    children,
    onSelectAll,
    selectAllLabel: t1,
    isFirmEmployeeOnly
  } = t0;
  const selectAllLabel = t1 === undefined ? "Select all" : t1;
  const {
    t
  } = useTranslation("document-viewer");
  let t2;
  if ($[0] !== onSelectAll || $[1] !== selectAllLabel) {
    t2 = onSelectAll ? <LinkButton onClick={onSelectAll}>{selectAllLabel}</LinkButton> : undefined;
    $[0] = onSelectAll;
    $[1] = selectAllLabel;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const rightContent = t2;
  let t3;
  if ($[3] !== headerTitle || $[4] !== rightContent) {
    t3 = <Card.Header title={headerTitle} rightContent={rightContent} />;
    $[3] = headerTitle;
    $[4] = rightContent;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isFirmEmployeeOnly || $[7] !== t) {
    t4 = isFirmEmployeeOnly && <InlineAlert variant="warning" className="mb-3">{t(_temp)}</InlineAlert>;
    $[6] = isFirmEmployeeOnly;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== t4) {
    t5 = <Card.Body><div className="p-4">{t4}{children}</div></Card.Body>;
    $[9] = children;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <Card.Root>{t3}{t5}</Card.Root>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default ContentCard;
function _temp($) {
  return $.centerPanel.hiddenFromTenants;
}